var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#72BC44"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2409_2329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8375 41.1876L37.3249 22.7001C37.1187 22.6439 36.9124 22.6251 36.6874 22.6251H19.8125C18.2562 22.6251 17 23.8814 17 25.4376V38.5626C17 39.7813 17.7687 40.8126 18.8375 41.1876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6504 24.5933L39.5005 27.6683V25.8252L46.7267 18.599C47.0923 18.2334 47.0923 17.639 46.7267 17.2734C46.3611 16.9077 45.7667 16.9077 45.4011 17.2734L17.2762 45.3983C16.9105 45.7639 16.9105 46.3583 17.2762 46.7239C17.6418 47.0895 18.2362 47.0895 18.6018 46.7239L23.9511 41.3745H36.688C38.2442 41.3745 39.5005 40.1183 39.5005 38.562V36.3308L45.6504 39.4058C45.9973 39.5539 46.3179 39.5145 46.5504 39.3683C46.8317 39.1808 47.0004 38.8808 47.0004 38.562V25.4371C47.0004 25.1183 46.8317 24.8183 46.5504 24.6308C46.2879 24.4621 45.9317 24.4433 45.6504 24.5933Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2409_2329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9999,
    height: 29.9999,
    fill: "white",
    transform: "translate(17 17.0001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOff);
export default __webpack_public_path__ + "static/media/Video-off.ab7b4be70b1bc098f75422019f9b8484.svg";
export { ForwardRef as ReactComponent };